<template>
    <div>
    <form @submit.prevent="submitForm">
          <div class="containerSearch">
              <table class="table searchTable">
                <tr>
                  <td>
                    Company name*
                  </td>
                  <td>
                  <input 
                    v-model="name"
                    type="text"
                    id="searchName"
                    class="form-control searchField"
                    :placeholder="newEntry == true ? 'Company name' : 'Name or external ID (If needed, search using different parts of the name)'"
                    required
                  />
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td>
                    Chamber of commerce
                  </td>
                  <td>
                  <input 
                    v-model="CompKvk"
                    type="text"
                    id="searchKvk"
                    class="form-control searchField"
                    placeholder="Chamber of commerce number"
                  />
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td>
                    VAT number
                  </td>
                  <td>
                  <input 
                    v-model="CompBTW"
                    type="text"
                    id="searchBTW"
                    class="form-control searchField"
                    placeholder="VAT number"
                  />
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td>
                    Phone number
                  </td>
                  <td>
                  <input 
                    v-model="CompPhMain"
                    type="text"
                    id="searchPhone"
                    class="form-control searchField"
                    placeholder="Phone number"
                  />
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td>
                    Website
                  </td>
                  <td>
                  <input 
                    v-model="CompWeb"
                    type="text"
                    id="searchWeb"
                    class="form-control searchField"
                    placeholder="Website URL"
                  />
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td>
                    Communities
                  </td>
                  <td>
                    <div class="col-md-2" v-for="(group, index) in chunkedItems" :key="index">
                        <div v-for="(item, index) in group" :key="index">
                          <input type="checkbox" :id="item.type_id" v-model="item.checked">
                          <label :for="item.type_id">{{ item.typedescr.replace(" Community member", "") }}</label>
                        </div>
                      </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    Country<i v-if="newEntry == true">*</i> <i v-if="newEntry != true">(optional)</i> 
                  </td>
                  <td>
                    <select name="CompNation" class="form-control" v-model="CompNation" :required="newEntry == true"  
                        :class="{ placeholder: !CompNation && !dropdownOpen }"
                        @focus="dropdownOpen = true"
                        @blur="dropdownOpen = false">
                      <option value=""  class="placeholder">Select Country</option>
                      <option 
                        v-for="(item, index) in countriesTimezonesSorted" 
                        :key="index" 
                        :value="item.country_code"
                        :disabled="item.isDivider"
                      >
                        {{ item.name }} <span v-if="item.country_code">({{ item.country_code }})</span>
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="newEntry == true && CompNation == 'US'">
                  <td>
                    State*
                  </td>
                  <td>
                    <select v-model="CompState" name="CompState" class="form-control" required>
                      <option v-for="(item, key, index) in usStates" :key="index" :value="item.abbreviation">
                        {{item.name}} ({{item.abbreviation}})
                      </option>
                    </select>
                  </td>
                </tr>
                <tr v-if="newEntry == true">
                  <td colspan="4">
                  <div class="alert alert-warning">
                    Warning, the company will be added without further checks
                  </div>
                  </td>
                </tr>
                <tr>
                  <td>
                  </td>
                  <td>
                    <button class="btn searchField btn-info" type="submit" v-if="newEntry == false">Search <div v-if="loading" id="loading"></div></button>
                    <button class="btn searchField btn-info" type="submit" v-if="newEntry == true">Save company and generate ID <div v-if="loading" id="loading"></div></button>
                    <button class="btn searchField" v-if="formSubmitted || newEntry == true" type="button" id="resetField" @click="reset" >Clear</button>
                    <button class="btn searchField btn-yellow" type="button" id="createNew" v-if="(newEntry == false && formSubmitted == true) || selectedValue" @click="newEntrySetup" style="float:right;">Create new External ID</button>
                  </td>
                </tr>
                <!--
                <tr v-if="newEntry == false && formSubmitted == false && selectedValue == false">
                  <td colspan="2">
                  Quick actions company: <br>
                  1. Retrieve or generate <b>external IDs.</b><br>
                  2. Add yourself as an <b>administrator.</b><br>
                  3. Add a company to relevant <b>communities.</b><br>
                  4. Check <b>company relations.</b><br><br>
                  <i>After clicking the search result, the options will appear.</i>
                </td>
                </tr>-->
                <tr v-if="newEntry == false && formSubmitted == false && selectedValue == false">
                  <td colspan="2">My current companies:</td>
                </tr>
                <tr v-if="newEntry == false && formSubmitted == false && selectedValue == false">
                  <td colspan="2"><span style="margin-left: -10px;width: calc(100% + 20px);display: block;margin-right: -10px;">
                  <span class="badge badge-info-fs" style="font-size: 14px;margin-bottom: 5px;cursor:pointer;" v-for="(item, key, index) in currentCompanies" :key="index" @click="onCompanyClicked(item.Company_Id, item.CompName)">
                    {{item.CompName}}
                    </span></span>
                  </td>
                  </tr>
                <tr v-if="selectedValue">
                  <td colspan="4" class="copied">
                    <br>
                    <b>External ID</b><br>
                    The external id: 
                    <b>{{selectedValue}}</b> 
                    is copied to clipboard <br>
                    <div v-if="companyLink == 0">
                    <hr style="border-color:#7a6b29;">
                    <b>FreightStation Admin</b><br>
                    Adding you as a Company admin will be invisible for the company itself<br><br>
                      <button class="btn btn-dark searchField" type="button" id="addCompany" @click="addCompany">Add myself to this company</button>
                    </div>
                    <div v-if="companyLink == 1 && companyID != 402">
                    <hr style="border-color:#7a6b29;">
                    <b>FreightStation Admin</b><br><br>
                      <button class="btn dark searchField" type="button" id="removeCompany" @click="removeCompany">Remove myself from this company</button>
                    </div>
                    <hr style="border-color:#7a6b29;">
                    <div style="display: table;border-spacing: 0;width:100%">
                    <b>Communities</b><br>
                    Add company to other communities:<br><br>
                      <div class="col-md-2" v-for="(group, index) in chunkedItems" :key="index">
                        <div v-for="(item, index) in group" :key="index">
                          <input type="checkbox" :id="item.type_id" v-model="item.checked">
                          <label :for="item.type_id">{{ item.typedescr.replace(" Community member", "") }} <span v-if="alreadyCommunities.includes(item.type_id)" class="glyphicon glyphicon-ok-sign comIcon"></span></label>
                        </div>
                      </div>
                    <div class="col-sm-12">
                      <br>
                      <button class="btn searchField btn-dark" type="button" id="updateCommunity" @click="updateCommunity">Save</button>
                    </div>
                    </div>
                    <hr style="border-color:#7a6b29;"></hr>
                    <b>Location(s) with shipments</b><br>
                    Only shipments within the last 3 months are considered whereby the selected company is the agent
                    <div v-if="!locations.length" style="margin-top:5px;">
                      <span class="badge badge-info-fs" style="font-size: 14px;margin-top: 5px;margin-left: 0px;font-style: italic;">No shipments found</span>
                    </div>
                    <div v-for="(location, index) in locations" :key="index">
                      <span class="badge badge-info-fs" style="font-size: 14px;margin-top: 5px;margin-left: 0px;">{{ location }}</span>
                    </div>
                    <button class="btn btn-dark searchField" type="button" id="showRelations" v-if="!showRelations && countRelations > 0" @click="showRelationsFunc(true)" style="margin-top: 20px;">Show relations ({{ countRelations }})</button>
                    <button class="btn dark searchField" type="button" id="showRelations" style="margin-bottom:15px;margin-top:20px;" v-if="showRelations && countRelations > 0" @click="showRelationsFunc(false)" >Hide relations ({{ countRelations }})</button>
                    <div v-if="showRelations">
                    <div v-for="(relations, type) in groupedRelations" :key="type">
                      <table class="table-bordered table-relations">
                        <thead>
                          <tr style="color:white;background-color:black;position:sticky;top:0;">
                            <td colspan="4" style="padding: 10px;font-size: 100%;">{{ relationTypes[type] || type }}</td>
                          </tr>          
                          <tr style="color:white;background-color:#3f3f3f;position:sticky;top:38.283px;" v-if="type != 3 && type != 6 && type != 7 && type != 8">
                            <td>ID</td>
                            <td>Haulier</td>
                            <td>Agent or Consigner</td>
                            <td>Creation date</td>
                          </tr>
                          <tr style="color:white;background-color:#3f3f3f;position:sticky;top:38.283px;" v-if="type == 3">
                            <td>ID</td>
                            <td>Subcontracted party</td>
                            <td>Original party</td>
                            <td>Creation date</td>
                          </tr>
                           <tr style="color:white;background-color:#3f3f3f;position:sticky;top:38.283px;" v-if="type == 6">
                            <td>ID</td>
                            <td>Agent (who's cargo is secured)</td>
                            <td>Security provider</td>
                            <td>Creation date</td>
                          </tr>
                          <tr style="color:white;background-color:#3f3f3f;position:sticky;top:38.283px;" v-if="type == 7">
                            <td>ID</td>
                            <td>Trusted Collector</td>
                            <td>Ground Handling agent (GHA)</td>
                            <td>Creation date</td>
                          </tr>
                          <tr style="color:white;background-color:#3f3f3f;position:sticky;top:38.283px;" v-if="type == 8">
                            <td>ID</td>
                            <td>In-house forwarder</td>
                            <td>Ground Handling agent (GHA)</td>
                            <td>Creation date</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(relation, index) in relations" :key="index">
                            <td>{{ relation.relation_id }}</td>
                            <td @click="onCompanyClicked(relation.role0_comp, relation.role0_name)" style="cursor:pointer;">{{ relation.role0_name }} ({{relation.role0_comp}})</td>
                            <td @click="onCompanyClicked(relation.role1_comp, relation.role1_name)" style="cursor:pointer;">{{ relation.role1_name }} ({{relation.role1_comp}})</td>
                            <td style="white-space: nowrap;">{{ relation.creation_date.slice(0, -3) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    </div>
                    <div>
                    <hr style="border-color:#7a6b29;">
                    <b>Company data</b><br>
                    <table class="table table-bordered table-compdata" style="margin-bottom:15px;margin-top: 5px;">
                      <tbody>
                        <tr v-if="companyData.iataNumbers && companyData.iataNumbers.length > 0">
                          <td style="width:180px;"><b>IATA Number(s)</b></td>
                          <td>
                            <span 
                              class="badge badge-info-fs"
                              style="font-size: 14px;margin-right:5px;margin-bottom:5px;"
                              v-for="(iataNumber, index) in companyData.iataNumbers"
                              :key="'iata-' + index"
                            >
                              {{ iataNumber }}
                            </span>
                          </td>
                        </tr>

                        <tr v-if="RAnumbers && RAnumbers.length > 0">
                          <td><b>RA Number(s)</b></td>
                          <td>
                            <span 
                              class="badge badge-info-fs"
                              style="font-size: 14px;margin-right:5px;margin-bottom:5px;"
                              v-for="(RAnumber, index) in RAnumbers"
                              :key="'ra-' + index"
                            >
                              {{ RAnumber }}
                            </span>
                          </td>
                        </tr>

                        <tr v-if="countryRegNumbers.type != 2">
                          <td style="min-width:200px;max-width:300px;"><b>{{ countryRegNumbers.govLabel ? countryRegNumbers.govLabel : 'Chamber of commerce' }}</b><br>
                          <span v-if="countryRegNumbers.type != 5" style="font-size:80%;"><i>(Chamber of commerce)</i></span></td>
                          <td><input 
                                type="text" name="CompKvK" class="form-control input-sm" style="background:#eeeeee;margin-left: 5px;max-width: 200px;padding: 2px 7px;height: 50%;border-radius: 6px;" v-model="companyData.CompKvK"></input></td>
                        </tr>

                        <tr v-if="countryRegNumbers.type != 1">
                          <td style="min-width:200px;max-width:300px;"><b>{{ countryRegNumbers.vatLabel ? countryRegNumbers.vatLabel : 'VAT number' }}</b><br>
                          <span v-if="countryRegNumbers.type != 5" style="font-size:80%;"><i>(VAT number)</i></span></td>
                          <td><input 
                                type="text" name="CompBTW" class="form-control input-sm" style="background:#eeeeee;margin-left: 5px;max-width: 200px;padding: 2px 7px;height: 50%;border-radius: 6px;" v-model="companyData.CompBTW"></input></td>
                        </tr>
                        </tbody>
                    </table>
                    <button 
                            class="btn btn-dark" 
                            type="button"
                            id="t101_btnCompData"
                            style="margin-left:8px;margin-bottom:8px;"
                            @click="updateCompanyData"
                          >
                            Update
                          </button> 
                    </div>
                  </td>  
                <!--<tr v-if="limited && newEntry == false">
                  <td colspan="4" class="limitedErr">
                    Results are limited to 50 entries
                  </td>  
                </tr>-->
            </table>
          </div>
      </form>

      <input type="text" value="" id="clipboard" style="position: absolute; left: -9999px; top: -9999px;"/>

      <b-table v-if="formSubmitted" class="queuetable-cargokiosk queuetable-monitor queuetable-archive borderless searchresults" id="queue" show-empty :items="searchResults" :fields="fields" @row-clicked="onRowClicked" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :hover="hover"  :filter="filter" :filter-included-fields="filterOn">
          <!--
        <template slot="top-row" slot-scope="{ fields }">
              <td colspan="6" class="table-search">
              <b-form-input id="filter-input" v-model="filter" type="search" v-bind:placeholder="typeToSearch()" > </b-form-input>
              <b-button  @click="filter = '';sortBy = 'start';sortDesc = true" id="clearFilters" style="display:none;"></b-button>
              </td>
          </template>
          -->
        <template v-slot:cell(CompID)="data">
          <span class="badge badge-info-fs" style="font-size: 110%;color: #4b4b4b;">{{ data.value }}</span>
        </template>
        <template v-slot:cell(CompNation)="data">
          <span v-html="countryState(data.item)"></span>
        </template>
        <template v-slot:cell(CompName)="data">
          <span v-html="compName(data.item)"></span>
        </template>
        <template v-slot:cell(fsusers)="data">
          <span v-html="fsusers(data.value)"></span>
        </template>
        <template v-slot:cell(shipments)="data">
          <span v-html="shipments(data.value)"></span>
        </template>
        <template v-slot:empty="scope">
          <h4><center>No results</center></h4>
        </template>
        <template #emptyfiltered="scope">
          <div style="text-align:center;">No results</div>
        </template>
      </b-table>
      </div>
  </template>
  <script>
  import countriesTimezones from "./data/countriesTimezones.json";
  import usStates from "./data/usStates.json";
  //import {VueTelInput} from 'vue-tel-input';

    export default {
      data() {
        return {
          name: "",
          CompKvk: "",
          CompBTW: "",
          CompPhMain: "",
          CompWeb: "",
          CompNation: "",
          CompState: "",
          searchResults: [],
          companyID: "",
          companyName: "",
          companyLink: "",
          companyRelations: [],
          formSubmitted: false,
          showRelations: false,
          RAnumbers: [],
          companyData: {},
          locations: [],
          companyDataUpdated: false,
          countryRegNumbers: {},
          currentCompanies: usercomps,
          hoveredCompany: null,
          loading: false,
          limited: false,
          newEntry: false,
          dropdownOpen: false,
          selectedValue: "",
          fields: [
          {key: 'CompID',label: 'External ID', sortable: true},
          {key: 'CompNation',label: 'Nation', sortable: true},
          {key: 'CompName',label: 'Name', sortable: true},
          {key: 'fsusers',label: 'FS users', sortable: true},
          {key: 'shipments',label: 'Shipments in FS (as agent)', sortable: true}
            ],
          hover: true,
          sortBy: '',
          sortDesc: true,
          filter: null,
          filterOn: ['CompName'],
          countriesTimezones: countriesTimezones,
          usStates: usStates,
          communities: communities,
          FScountries: FScountries,
          alreadyCommunities: [],
          relationTypes: {
            1: 'EXPORT - SECURE',
            2: 'EXPORT - NON SECURE',
            3: 'EXPORT/IMPORT - SUBCONTRACT HAULIER',
            4: 'IMPORT',
            5: 'STATION DECLERATION',
            6: 'CARGO SCREENING AGREEMENT',
            7: 'HANDLER - TRUSTED COLLECTOR',
            8: 'HANDLER - IN-HOUSE FORWARDER',
          }
        };
      },
      computed: {
        countriesTimezonesSorted() {
          // Separate FS and non-FS countries
          const fsCountries = this.countriesTimezones.filter(c => FScountries.includes(c.country_code))
            .sort((a, b) => a.name.localeCompare(b.name));

          const otherCountries = this.countriesTimezones.filter(c => !FScountries.includes(c.country_code))
            .sort((a, b) => a.name.localeCompare(b.name));

          // Insert a divider
          if (fsCountries.length && otherCountries.length) {
            fsCountries.push({ name: '──────────', country_code: null, isDivider: true });
          }

          return [...fsCountries, ...otherCountries];
        },
        chunkedItems() {
          var NumPerRow = Math.ceil(communities.length / 6);
          return this.chunkArray(communities, NumPerRow);
        },
        groupedRelations() {
          const transTable = {
            2268: 1,
            2328: 2,
            2289: 3,
            2321: 4,
            2330: 5,
            2530: 6,
            2563: 7,
            2565: 8
          };

          return this.companyRelations.reduce((groups, item) => {
            const type = transTable[item.relation_type] || 'Unknown';

            if (!groups[type]) {
              groups[type] = [];
            }

            groups[type].push(item);

            return groups;
          }, {});
        },
        countRelations() {
          return this.companyRelations.length;
        }
      },
      mounted() {
        document.addEventListener('click', this.handleClickOutside);
      },
      beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
      },
      methods: {
        chunkArray(arr, size) {
          return arr.reduce((acc, _, i) => 
            (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);
        },
        fsusers(value) {
          if(value == 0) {
            return '<span class="badge"style="background:#dddddd;color:#3f3f3f;opacity:0.7;">0</span>';
          } else {
            return '<span class="badge" style="background:#fadc32;color:#3f3f3f;">'+ value + '</span>';
          };
        },
        shipments(value) {
          if(value == 0) {
            return '<span class="badge"style="background:#dddddd;color:#3f3f3f;opacity:0.7;">-</span>';
          } else {
            let companies = value;
            let badges = companies.map(c => {
                return '<span class="badge" style="background:#fadc32;color:#3f3f3f;margin-right:3px;">' + c.trim() + '</span><br>';
            });
            return badges.join('');
          };
        },
        compName(value) {
          if(value.ralocs > 0) {
            return value.CompName.toUpperCase() + ' <span class="badge" style="background:#fadc32;color:#3f3f3f;">RA</span>';
          } else {
            return value.CompName.toUpperCase();
          };
        },
        submitForm: function () {
          this.formSubmitted = false;
          this.limited = false;
          this.loading = true;
          this.selectedValue = "";
          this.alreadyCommunities = [];
          var newCommunities = [];
          this.communities.forEach(function(item) {
            if(item.checked) {
              newCommunities.push(item.type_id);
            }
          });
          var self = this;
          var searchJob = {newEntry: this.newEntry, name:this.name, CompKvk: this.CompKvk, CompBTW: this.CompBTW, CompPhMain: this.CompPhMain, CompWeb: this.CompWeb, CompNation: this.CompNation, CompState: this.CompState, communities: newCommunities};
          if(this.name == "") {
            this.loading = false;
            this.formSubmitted = false;
            return;
          };
          $.post('t110/f002', {
            _token: $('meta[name=csrf-token]').attr('content'),
            searchJob: searchJob,
          })
          .fail(function(data) {
              console.log('error in search query');
              self.searchResults = {};
              self.formSubmitted = false;
              self.loading = false;
              self.limited = false;
          })
          .done(function(data) {
              if(self.newEntry) {
                self.formSubmitted = true;
                self.loading = false;
                $('#clipboard:text').val(data + ' - ' + self.name.toUpperCase());
                var copyText = $('#clipboard')[0];
                copyText.select();
                copyText.setSelectionRange(0, 99999); /*For mobile devices*/
                document.execCommand("copy");
                self.companyID = data;
                self.locations = [];
                self.companyName = self.name;
                self.selectedValue = data + ' - ' + self.name.toUpperCase();
                self.reset();
                self.alreadyCommunities = newCommunities;
                self.communities.forEach(function(item) {
                  if(self.alreadyCommunities.includes(item.type_id)) {  
                    item.checked = true;
                  } else {
                    item.checked = false;
                  }
                });

              } else {
                self.communities.forEach(function(item) {
                  item.checked = false;
                });
                self.searchResults = data;
                self.formSubmitted = true;
                self.loading = false;
                if(data && data.length == 50) {
                  self.limited = true;
                } else {
                  self.limited = false;
                }
              }
          })
        },
        reset() {
          this.searchResults = {};
          this.formSubmitted = false;
          this.limited = false;
          this.loading = false;
          this.newEntry = false;
          this.name = '';
          this.CompKvk = '';
          this.CompBTW = '';
          this.CompPhMain = '';
          this.CompWeb = '';
          //this.CompNation = '';
          this.CompState = '';
          this.alreadyCommunities = [];
          this.countRelations = 0;
          this.companyLink = '';
          this.companyRelations = [];
          this.RAnumbers = [];
          this.companyData = {};
          this.locations = [];
          this.countryRegNumbers= {};
          this.communities.forEach(function(item) {
            item.checked = false;
          });
        },
        newEntrySetup() {
          this.newEntry = true;
          this.alreadyCommunities = [];
          this.communities.forEach(function(item) {
            item.checked = false;
          });
          this.selectedValue = "";
          this.formSubmitted = false;
        },
        showRelationsFunc(toggle = false) {
          if(toggle == true) {
            this.showRelations = true;
          } else {
            this.showRelations = false;
          }
        },
        addCompany() {
          var self = this;
          $.post('t110/f006', {
            _token: $('meta[name=csrf-token]').attr('content'),
            companyID: self.companyID,
            companyName: self.companyName,
            type: 'add'
          })
          .fail(function(data) {
              console.log('error');
          })
          .done(function(data) {
            self.companyLink = 1;
            $('#main_compselect').load(document.URL +  ' #main_compselect>*');
            $('#main_compselect').append('<input type="hidden" name="_token" value="' + $('meta[name=csrf-token]').attr('content') + '">');
            self.currentCompanies.push({ Company_Id: self.companyID, CompName: self.companyName });
          });
        },
        removeCompany(compID = null) {
          if(compID == null || compID instanceof PointerEvent) {
            compID = this.companyID;
          }
          var self = this;
          $.post('t110/f006', {
            _token: $('meta[name=csrf-token]').attr('content'),
            companyID: compID,
            type: 'delete'
          })
          .fail(function(data) {
              console.log('error');
          })
          .done(function(data) {
            self.companyLink = 0;
            $('#main_compselect').load(document.URL +  ' #main_compselect>*');
            $('#main_compselect').append('<input type="hidden" name="_token" value="' + $('meta[name=csrf-token]').attr('content') + '">');
            self.currentCompanies = self.currentCompanies.filter(Company => Company.Company_Id !== compID);
          });
        },        
        updateCommunity() {
          var newCommunities = [];
          var removeCommunities = [];
          var self = this;
          this.communities.forEach(function(item) {
            if(item.checked && !self.alreadyCommunities.includes(item.type_id)) {
              newCommunities.push(item.type_id);
            }
            if(!item.checked && self.alreadyCommunities.includes(item.type_id)) {
              removeCommunities.push(item.type_id);
            }
          });

          var CompID = this.selectedValue.split(' - ')[0];

          if(newCommunities.length > 0) {
            $.post('t110/f004', {
                _token: $('meta[name=csrf-token]').attr('content'),
                CompID: CompID,
                newCommunities: newCommunities,
              })
              .fail(function(data) {
                console.log('error in function updateCommunity (add)');
              })
              .done(function(data) {
                self.alreadyCommunities = [].concat(self.alreadyCommunities, data);
                self.communities.forEach(function(item) {
                  if(self.alreadyCommunities.includes(item.type_id)) {
                    item.checked = true;
                  } else {
                    item.checked = false;
                  }
                });
              });
          };
          if(removeCommunities.length > 0) {
              $.post('t110/f004a', {
                _token: $('meta[name=csrf-token]').attr('content'),
                CompID: CompID,
                removeCommunities: removeCommunities,
              })
              .fail(function(data) {
                console.log('error in function updateCommunity (remove)');
              })
              .done(function(data) {
                self.alreadyCommunities = self.alreadyCommunities.filter(function(id) {
                  return !removeCommunities.includes(id);
                });
              });
          }
        },
        countryState(item) {
          if(item.CompNation == 'US') {
            return item.CompNation.toUpperCase() + ' <small>' + item.CompState.toUpperCase() + '</small>';
          } else {
            return item.CompNation.toUpperCase();
          };
        },
        onCompanyClicked (CompID, CompName) {
          var item = { CompID: CompID, CompName: CompName };
          this.onRowClicked(item,null,null);
        },
        onRowClicked (item, index, event) {
          $('#clipboard:text').val(item.CompID + ' - ' + item.CompName.toUpperCase());
          var copyText = $('#clipboard')[0];
          copyText.select();
          copyText.setSelectionRange(0, 99999); /*For mobile devices*/
          document.execCommand("copy");
          this.reset();
          var self = this;
          this.selectedValue = item.CompID + ' - ' + item.CompName.toUpperCase();
            $.post('t110/f003', {
              _token: $('meta[name=csrf-token]').attr('content'),
              CompID: item.CompID
            })
            .fail(function(data) {
              console.log('error in function onRowClicked');
            })
            .done(function(data) {
              self.alreadyCommunities = data[0];
              self.companyLink = data[1];
              self.companyRelations = data[2];
              self.RAnumbers = data[3];
              self.companyData = data[4];
              self.locations = data[5];
              self.countryRegNumbers = data[6];
              self.companyID = item.CompID;
              self.companyName = item.CompName;
              self.communities.forEach(function(item) {
                if(self.alreadyCommunities.includes(item.type_id)) {
                  item.checked = true;
                } else {
                  item.checked = false;
                }
              });
              window.scrollTo(0, 0);
            });
        },
        handleClickOutside(event) {
          if(event.target.id) {
            var idParts = event.target.id.split('-');
            if(idParts[0] == 'btncomp') {
              var item = {};
              var compDetails = idParts[1].split('/');
              item.CompID = compDetails[0];
              item.CompName = compDetails[1];
              this.onRowClicked(item,null,null);
              window.scrollTo(0, 0);
            }
          }
        },
        updateCompanyData() {
          var self = this;

          let data = {
            CompKvK: self.companyData.CompKvK || null,
            CompBTW: self.companyData.CompBTW || null,
            CompID: self.companyID,
          };

          $.ajax({
            url: '/t101/f011',
            type: 'POST',
            data: data,
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',

            success(response) {
              if (response.success) {
                  var item = { CompID: self.companyID, CompName: self.companyName };
                  self.onRowClicked(item,null,null);
              } else {
                alert('Error: ' + (response.message || 'Update failed.'));
              }
            },

            error(xhr, status, error) {
              console.error('AJAX error:', status, error);
              alert('An error occurred while updating company data.');
            }
          });
        },
        noQueue () {
          return 'No results';
        },
        filteredOut () {
          return 'No results';
        },
        typeToSearch () {
          return 'Type to search';
        },
      },
    };
  </script>
  <style>
  .inputname {
    text-align:left;
  }
  .searchTable {
    border-collapse: separate;
    border-spacing: 20px;
    margin-bottom:0px;
  }
  .containerSearch {
    text-align:left;
    margin-right:auto;
  }
  .queuetable-archive > thead > tr > th,   .queuetable-archive> thead > tr > td{
    border: 0 !important;
    font-family: 'Work Sans' !important;
    font-weight: 500 !important;
    padding: 2rem !important;
    vertical-align: middle !important;
}
  .queuetable-archive > tbody > tr > th,   .queuetable-archive > tbody > tr > td,  .queuetable-archive > tfoot > tr > th,  .queuetable-archive > tfoot > tr > td {
    border: 0 !important;
    font-family: 'Work Sans' !important;
    font-weight: 300 !important;
    padding: 2rem !important;
    vertical-align:middle !important;
}
  .queuetable-archive {
    margin:0px;
  }
  .queuetable-archive th {
    cursor: pointer;
  }
  .queuetable-archive > thead > tr > th:hover {
    background-color: #f5f5f5;
  }
  #loading {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 1px solid #dbdbdb;
    border-radius: 50%;
    border-top-color: #000;
    margin-bottom:-3px;
    margin-left: 5px;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  .limitedErr {
    text-align: center;
    font-style: italic;
    background-color: #474747;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
  }
  .copied {
    background-color: #ffd832;
    color: #252525;
    border-radius: 4px;
    padding: 15px;
  }
  .scontainer{
    overflow: hidden;
    background-color: #eee;
    text-align: center;
    cursor: pointer;
    margin:2px;
    padding: 0.5rem;
    font-family: 'Work Sans';
    font-weight: 400 !important;
    font-size: 1.2rem;
}

.queuetable-cargokiosk tbody {
    cursor: pointer;
}

.comIcon {
  opacity:0.5;
  scale: 0.75;
  margin-left: -3px;
}

.table-relations, .table-relations > tbody > tr > td, .table-relations > tbody > tr > th, .table-relations > tfoot > tr > td, .table-relations > tfoot > tr > th, .table-relations > thead > tr > td, .table-relations > thead > tr > th {
  background:none !important;
  border: 0.5px solid #3f3f3f !important;
  padding:1px 4px 1px 4px;
  font-size:95%;
}

.table-relations {
  margin-bottom: 20px;
  width: 100%;
}

.table-compdata, .table-compdata > tbody > tr > td, .table-compdata > tbody > tr > th, .table-compdata > tfoot > tr > td, .table-compdata > tfoot > tr > th, .table-compdata > thead > tr > td, .table-compdata > thead > tr > th {
  background:none !important;
  border-color: white;
}

.table-compdata {
  margin-bottom: 20px;
  width: 100%;
}

.placeholder {
  font-weight: 400;
  font-style:italic;
}
  </style>